/* unplugin-vue-components disabled */import { render } from "./BaseNavbar.vue?vue&type=template&id=8e667818&scoped=true"
import script from "./BaseNavbar.vue?vue&type=script&lang=js"
export * from "./BaseNavbar.vue?vue&type=script&lang=js"

import "./BaseNavbar.vue?vue&type=style&index=0&id=8e667818&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e667818"]])

export default __exports__